/**
 * Created by Ning Jiang on 8/23/2017.
 */

import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {gsap, TimelineLite} from "gsap";

export interface IMultiSpritesConfig {
    name:string,
    textures:PIXI.Texture[],
    anchor?:PIXI.ObservablePoint,
    fps?:number,
}

export class MultiSprites extends PIXI.Container {

    public readonly sprites:{ [name:string]:TimelineSprite };
    private _currentSprite:TimelineSprite;
    private _currentSpriteName:string;

    get currentSprite():TimelineSprite {
        return this._currentSprite;
    }

    get currentSpriteName():string {
        return this._currentSpriteName;
    }

    constructor() {
        super();
        this.sprites = {};
    }

    public addSprites(...config:IMultiSpritesConfig[]):void {
        config.forEach(c => {
            const animation = new TimelineSprite(c.textures, c.fps ? c.fps : 30);
            if(c.anchor) {
                animation.anchor.set(c.anchor.x, c.anchor.y);
            }
            animation.visible = false;
            this.sprites[c.name] = animation;
            this.addChild(animation);
        });
    }

    // prop is for tweening on the image's prop, such as tweening the x of image.scale.
    public playSprite(name:string, tweenInConfig:gsap.TweenVars, tweenOutConfig:gsap.TweenVars, frames?:number[]):TimelineLite {
        return this.playSpriteFromTo(name, {}, tweenInConfig, tweenOutConfig, frames);
    }

    // prop is for tweening on the image's prop, such as tweening the x of image.scale.
    public playSpriteFromTo(name:string, tweenInFrom:gsap.TweenVars, tweenInTo:gsap.TweenVars, tweenOut:gsap.TweenVars, frames?:number[]):TimelineLite {
        const newSprite = this.sprites[name];
        // const oldSprite = this._currentSprite;

        // we don't use fromTo cos it messes up with chain animations.
        tweenInFrom.duration = 0.001;
        const tl = new TimelineLite();
        tl.add(() => {
            newSprite.visible = true;
            this._currentSpriteName = name;
            this._currentSprite = newSprite;
        });
        tl.add(gsap.to(newSprite, tweenInFrom));
        tl.add([
            gsap.to(newSprite, tweenInTo),
            newSprite.getAnimation(frames)
        ]);

        for(const otherName in this.sprites) {
            if(name != otherName) {
                const otherSprite = this.sprites[otherName];
                tl.add(gsap.to(otherSprite, tweenOut), 0);
                tl.add(() => {otherSprite.visible = false});
            }
        }
        return tl;
    }
}